import { useQuery } from '@tanstack/react-query'
import { RunView } from './components/RunView.tsx'
import { useTRPC } from './trpc.ts'

export function App() {
  const trpc = useTRPC()
  // There is no sign-in yet: everyone plays as the same shared player. This is
  // still the gate the app waits on, so a login screen slots in here later.
  const me = useQuery(trpc.auth.me.queryOptions())

  if (me.isPending) {
    return <Centered>Loading…</Centered>
  }

  if (me.isError) {
    return (
      <Centered>
        <span className="text-rose-400">{me.error.message}</span>
      </Centered>
    )
  }

  return <RunView user={me.data} />
}

function Centered({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-dvh items-center justify-center text-sm text-stone-500">
      {children}
    </div>
  )
}
